// src/components/EmployeeCard.js
import React from 'react';
import { Link } from 'react-router-dom';

const EmployeeCard = ({ employee }) => {
  return (
    <div style={{ width: '300px', backgroundColor: '#111', borderRadius: '10px', overflow: 'hidden', color: '#fff', boxShadow: '0 2px 10px rgba(255, 255, 255, 0.1)' }}>
      <Link to={`/employee/${employee.id}`} style={{ textDecoration: 'none', color: 'white' }}>
        <img src={employee.images[0]} alt={employee.name} width="100%" height="400" style={{ objectFit: 'cover' }} />
        <div style={{ padding: '10px' }}>
          <h3 style={{ margin: '0 0 5px' }}>{employee.name.toUpperCase()}</h3>
          <p style={{ margin: 0 }}>{employee.age} | {employee.location}</p>
        </div>
      </Link>
    </div>
  );
};

export default EmployeeCard;